module.exports = __webpack_public_path__ + "static/flags/MI-224a355411d6bc8a50c9814e00df1815.gif";